import { RowActionButton } from './RowActionButton';
import { RowActionGroup } from './RowActionGroup';

interface RowEditDeleteButtonsProps<TItem> {
  item: TItem;
  itemName: string;
  onEdit?: ((item: TItem) => void) | undefined;
  onDelete?: ((item: TItem) => void) | undefined;
}

export function RowEditDeleteButtons<TItem>({
  item,
  itemName,
  onEdit,
  onDelete,
}: RowEditDeleteButtonsProps<TItem>) {
  return (
    <RowActionGroup>
      {onEdit && (
        <RowActionButton label="Edit" ariaLabel={`Edit ${itemName}`} onClick={() => onEdit(item)} />
      )}
      {onDelete && (
        <RowActionButton
          label="Delete"
          ariaLabel={`Delete ${itemName}`}
          onClick={() => onDelete(item)}
          tone="destructive"
        />
      )}
    </RowActionGroup>
  );
}
